import { Breadcrumb, Button, Col, message, Row, Steps } from "antd";
import { _adr } from "../../../../../address";
import IncressCharge from "../../../../auxiliary/incressCharge/charge";
import Loading from "../../../../auxiliary/loader/loading";
import { Content } from "antd/es/layout/layout";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useAPIPublic, useDealer } from "../../../../../tools/api";
import { complexDigitToman, fileToBase64, isEmpty } from "../../../../../tools/tools";
import { globalValue } from "../../../../../reducer/serviceReducerGlobala";
import Profile from "../../profile/profile";

const CoSimPrefactor = () => {
	const [t] = useTranslation("global");
	const formData = useSelector((state) => state);
	const dispatch = useDispatch();
	const [searchParam] = useSearchParams();
	const nav = useNavigate();
	const [messageApi, contextHolder] = message.useMessage();
	const { sWPreFactor } = useDealer();
	const { queryTaxPercent } = useAPIPublic();
	const bankRef = useRef("");

	const [pre, setPre] = useState({
		previewData: formData?.from?.swchange || {},
		newKit: formData?.from?.swchange?.newKit,
		openIncress: false,
		localInvoiceId: "",
		isLoading: false,
		priceSw: 0,
		purchaseID: 0,
		tax: 0,
		taxPrice: 0,
		wallet: 0,
		changeWallet: "",
	});

	useEffect(() => {
		const initialCheckState = async () => {
			if (!isEmpty(searchParam.get("localInvoiceId"))) {
				formData.from = formData?.another.swchange;
				setPre((pre) => ({
					...pre,
					previewData: formData?.another.swchange,
					getLocalInvoiceID: searchParam.get("localInvoiceId") || "",
					openIncress: true,
					purchaseID: formData?.another.swchange.purchaseid,
				}));
			} else {
				setPre((pre) => ({ ...pre }));
			}
		};
		initialCheckState();
	}, []);
	useEffect(() => {
		const CallInitial = async () => {
			let resTax = await queryTaxPercent();
			if (resTax) setPre((pre) => ({ ...pre, tax: parseInt(resTax) }));
			//call CalC Price SW
			let payload = {
				msisdn: pre.previewData?.purchase?.inT_MSISDN,
				certno: pre.previewData?.purchase?.stR_CertNo,
			};
			let response = await sWPreFactor(payload);
			if (response) {
				setPre((pre) => ({ ...pre, priceSw: response.productPrice, purchaseID: response.spPurchaseId }));
			}
		};
		if (pre.previewData) {
			CallInitial();
		}
	}, [pre.previewData]);
	useEffect(() => {
		if (pre.tax > 0 && pre.priceSw > 0) {
			let total = (pre.priceSw * pre.tax) / 100;
			setPre((pre) => ({ ...pre, taxPrice: total }));
		}
	}, [pre.tax, pre.priceSw]);
	useEffect(() => {
		setPre((pre) => ({ ...pre, wallet: formData?.another?._currentUser?.walletAmount || 0 }));
	}, [formData?.another?._currentUser?.walletAmount, pre.changeWallet]);
	const handleCallBackCharge = (value) => {
		if (value?.length > 0) {
			// dispatch(clearFormData());
			dispatch(globalValue({ swchange: { ...formData.from, purchaseid: pre.purchaseID } }));
			bankRef.current.innerHTML = value;
			document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
		} else {
			setPre((pre) => ({ ...pre, localInvoiceId: "", openIncress: false, setChangeWallet: Date.now() }));
		}
	};
	const handleSubmit = async () => {
		if (pre.purchaseID) {
			nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.Final, {
				state: {
					spPurchaseId: pre.purchaseID,
				},
			});
		} else {
			messageApi.open({
				type: "error",
				content: "شناسه خرید وجود ندارد",
			});
		}

		// if (wallet - (taxPrice + priceSw) >= 0) {

		// } else {
		//   messageApi.open({
		//     type: "error",
		//     content: "موجودی کیف پول کافی نمی باشد.",
		//   });
		// }
	};
	return (
		<>
			<div className="container-main container-cs">
				{contextHolder}
				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardreplacement.legal.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardreplacement.legal.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main cs-container">
						<div className="g-format-page">
							<Profile Profile={pre?.previewData?.purchase} state />
							<br />
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={2}
											items={[
												{
													title: "احراز هویت",
												},
												{
													title: "مشخصات سیم‌کارت",
												},
												{
													title: "پیش فاکتور",
												},
											]}
										/>
									</div>
								</div>
								<div className="cs-prefactor-container">
									<div className="g-prefactor">
										<div className="holder-row-prefactor">
											<Row gutter={16}>
												<Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
													<div className="for-pay-client">
														<h3>صورت حساب مشتری</h3>
														<div className="holder-box">
															<div className="holder-profile">
																<h4>
																	مشخصات سیم کارت{" "}
																	<Link to={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.ValidKit}>
																		<i className="icon-edit"></i>
																	</Link>
																</h4>
																<div className="list-item">
																	<div className="item">
																		<div className="label">شماره موبایل:</div>
																		<div className="value">
																			<span dir="ltr">{pre.previewData?.purchase?.inT_MSISDN}</span>
																		</div>
																	</div>
																	<div className="item">
																		<div className="label">کد ملی:</div>
																		<div className="value">
																			<span dir="ltr">{pre.previewData?.purchase?.stR_CertNo}</span>
																		</div>
																	</div>
																</div>
															</div>
															<div className="divider"></div>
															<div className="holder-profile">
																<div className="list-item">
																	<div className="item">
																		<div className="label">شماره کیت جدید:</div>
																		<div className="value">
																			<span dir="ltr">{pre.previewData?.newKit}</span>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</Col>
												<Col span={10} xl={10} lg={10} md={24} sm={24} xs={24} style={{ display: "none" }}>
													<div className="for-pay-agent">
														<h3>صورت حساب فروشنده</h3>
														<div className="holder-box">
															<div className="holder-list-pay">
																<ul>
																	<li>
																		<div className="label">هزینه تعویض سیم‌کارت</div>
																		<div className="value">
																			<span dir="ltr">{complexDigitToman(pre.priceSw)}</span> تومان
																		</div>
																	</li>
																	<li>
																		<div className="label">مالیات ({pre.tax}درصد)</div>
																		<div className="value">
																			<span dir="ltr">{complexDigitToman(pre.taxPrice)}</span> تومان
																		</div>
																	</li>
																	<li>
																		<div className="label">مبلغ قابل دریافت از مشتری</div>
																		<div className="value">
																			<span dir="ltr">{complexDigitToman(pre.taxPrice + pre.priceSw)}</span> تومان
																		</div>
																	</li>
																</ul>
																<div className="hold-message success">
																	<p>این مبلغ از کیف پول شما برداشت می‌شود</p>
																	<h3>
																		<span dir="ltr">{0}</span>
																		تومان
																	</h3>
																</div>
																{/* {wallet - (taxPrice + priceSw) >= 0 ? (
																	""
																	) : (
																	<>
																		<div className="hold-message success">
																		<p>این مبلغ از کیف پول شما برداشت می‌شود</p>
																		<h3>
																			<span dir="ltr">{complexDigitToman(taxPrice + priceSw)}</span>
																			تومان
																		</h3>
																		</div>
																		<div className="hold-message error">
																		<div className="row-message">
																			<div className="holder-text">
																			<h3>اعتبار شما کافی نمی‌باشد</h3>
																			<ul>
																				<li>
																				<div className="label">کسری اعتبار: </div>
																				<div className="value">
																					<span dir="ltr">{complexDigitToman(taxPrice + priceSw - wallet)} </span> تومان
																				</div>
																				</li>
																			</ul>
																			</div>
																			<div className="holder-acction">
																			<div className="holder-button">
																				<Button className="btn-normal" htmlType="button" onClick={() => setOpenIncress(true)}>
																				افزایش اعتبار
																				</Button>
																			</div>
																			</div>
																		</div>
																		</div>
																	</>
																	)} */}
															</div>
														</div>
													</div>
												</Col>
											</Row>
										</div>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="holder-button">
									<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmit}>
										ثبت نهایی
									</Button>
									<Button
										className="btn-normal"
										onClick={() => {
											nav(_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.ValidKit);
										}}
										type="default">
										بازگشت
									</Button>
								</div>
							</div>
						</div>
					</Content>
				</div>
			</div>

			<Loading isOpen={pre.isLoading} />
			<IncressCharge
				open={pre.openIncress}
				planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_CS}
				msisdn={formData?.another?._currentUser?.telnoone}
				price={pre.taxPrice + pre.priceSw - pre.wallet}
				callback={handleCallBackCharge}
				localInvoiceId={pre.localInvoiceId}
			/>
			<div ref={bankRef}></div>
		</>
	);
};

export default CoSimPrefactor;
